import React from 'react'
import Navbar from '../Navbar/Navbar'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import "./Privacy.css"
import Footer from '../Footer/Footer'

const Privacy = () => {
  return (
    <div>
      <Navbar />
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h4" sx={{ fontFamily: "rubik", fontWeight: "bold", textAlign: "center", marginTop: "0.5rem" }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="gray" sx={{ fontFamily: "rubik" }}>
          Last Updated on 08-04-25 14:23:04
        </Typography>
      </Box>
      <Box sx={{ maxWidth: 800, mx: "auto", mt: 3, p: 2, textAlign: "justify" }}>
        <Typography sx={{ mb: 2 }}>
          SUBH BHARAT STUDY TOOL PVT LTD (“Company”, “we”, “our”, or “us”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website sabka.com and use our licensed mobile application (collectively, the “Platform”).
        </Typography>
        <Typography sx={{ mb: 2 }}>
          Please read this privacy policy carefully. If you do not agree with the terms of this policy, please do not access the Platform.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>1. Information We Collect</Typography>
        <Typography>We may collect the following types of information:</Typography>
        <Typography sx={{ mt: 1, fontWeight: "bold" }}>a) Personal Information</Typography>
        <ul>
          <li>Name, email address, contact number</li>
          <li>Date of birth, gender</li>
          <li>Resume/CV, employment history, educational qualifications</li>
          <li>Identity verification documents (if applicable)</li>
        </ul>
        <Typography sx={{ mt: 1, fontWeight: "bold" }}>b) Non-Personal Information</Typography>
        <ul>
          <li>IP address, browser type, device information</li>
          <li>Location data</li>
          <li>Platform usage patterns and activity logs</li>
        </ul>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>2. How We Use Your Information</Typography>
        <ul>
          <li>Facilitate job search and recruitment services</li>
          <li>Communicate with you regarding your account or service requests</li>
          <li>Improve the functionality and user experience of the Platform</li>
          <li>Match Job Seekers with Recruiters</li>
          <li>Send service updates, promotional material, or newsletters (with your consent)</li>
          <li>Prevent fraudulent or unauthorized activity</li>
        </ul>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>3. Sharing of Information</Typography>
        <ul>
          <li>Verified recruiters or employers to fulfill the Purpose of the platform</li>
          <li>Service providers and partners who assist in Platform operations (under confidentiality agreements)</li>
          <li>Law enforcement or government agencies, if required by law</li>
        </ul>
        <Typography sx={{ mb: 2 }}>
          We do not sell or rent your personal information to third parties for their marketing purposes.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>4. Data Security</Typography>
        <Typography sx={{ mb: 2 }}>
          We use administrative, technical, and physical safeguards to protect your personal data. However, no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>5. Your Rights and Choices</Typography>
        <ul>
          <li>You may review, update, or delete your profile and personal information at any time by logging into your account.</li>
          <li>You can opt out of receiving promotional emails by clicking the “unsubscribe” link.</li>
        </ul>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>6. Cookies and Tracking Technologies</Typography>
        <Typography sx={{ mb: 2 }}>
          We may use cookies and similar technologies to enhance your experience on the Platform. You may disable cookies in your browser settings; however, this may affect certain features of the Platform.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>7. Third-Party Links</Typography>
        <Typography sx={{ mb: 2 }}>
          The Platform may contain links to third-party websites or services. We are not responsible for the privacy practices or content of such third-party services.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>8. Children’s Privacy</Typography>
        <Typography sx={{ mb: 2 }}>
          Our Platform is not intended for individuals under the age of 18. We do not knowingly collect data from minors.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>9. Changes to This Policy</Typography>
        <Typography sx={{ mb: 2 }}>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated effective date.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>10. Contact Us</Typography>
        <Typography>
          If you have any questions about this Privacy Policy or wish to exercise your data rights, please contact:
        </Typography>
        <Box sx={{ mt: 1, mb: 2, pl: 2 }}>
          <Typography>SUBH BHARAT STUDY TOOL PVT LTD</Typography>
          <Typography>Email: <a href="mailto:sbobby065@gmail.com">sbobby065@gmail.com</a></Typography>
          <Typography>Phone: <a href="tel:+919603198840">9603198840</a></Typography>
          <Typography>Address: 4-8-40, Chinnadevara Street, Ichapuram, Srikaulam, AP 532127.</Typography>
        </Box>
      </Box>
      <Footer/>
    </div>
  )
}

export default Privacy